// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"f4ae03e3","739":"22efe708","963":"407f7ee7"}[chunkId] + ".chunk.js";
};